
import { Address } from "@/model/Address";
import type { Address as AddressType } from  "@/scripts/Common/types"
import Vue, {PropType} from "vue";
import VueI18n from "vue-i18n";

export default Vue.extend({
  props: {
    label: {
      required: true,
      type: String as PropType<string | VueI18n.TranslateResult>
    },
    model: {
      required: true,
      type: Object as PropType<Address | AddressType>
    },
    HasNoEditRights: Boolean,
    expanded: {
      required: false,
      type: Array as PropType<Array<number>>,
      default() {
        return [1]
      }
    },
  },
  data: function () {
    return {
      valid: true,
      constants:{
        streetCharacterLength: 50,
        zipCodeCharacterLength: 10,
        townCharacterLength: 50
      },
      internalExpand: this.expanded,
    };
  },
  computed: {
    rules() {
      return {
        required: (value: string) =>
          !!value || this.$t("Rules.Required"),
        max: (maxLength: number, value: string) =>
          (!!value && value.length <= maxLength) ||
          this.$t("Rules.Max", { maxLength: maxLength }),
      };
    },
  },
  methods: {
    validate() {
      (this.$refs.form as any).validate();
    },
    resetValidation() {
      (this.$refs.form as any).resetValidation();
    },
  },
  watch: {
    valid: function (value) {
      this.validate();
      this.$emit("ValidChanged", value);
    },
    expanded: function (value){
      this.internalExpand = value;
    }
  },
});
